<template>
  <div :class="['filter-options', 'filter-' + scope]">
    <template v-if="mode != 'mini'">
      <!-- <h2 class="title title-1st">{{title}}</h2> -->
      <h2 class="title title-2rd">筛选</h2>
    </template>
    <!-- 过滤条件：性别 -->
    <template v-if="filterOpts.genders.items">
      <div class="filter-item">
        <a class="item-header" @click="toggle('genders')">
          <span :class="['title', filterOpts.genders.collapse?'':'title-expand']">性别</span>
          <i class="iconfont">{{filterOpts.genders.collapse? '&#xe61e;' : '&#xe613;'}}</i>
        </a>
        <div :class="['item-list-wrapper', filterOpts.genders.collapse?'':'active']">
          <ul class="item-list item-icon">
            <li v-for="(item,i) in filterOpts.genders.items" :key="i" @click="toggleItem('genders', item.id)">
              <i class="iconfont">{{filterOpts.genders.checked.indexOf(String(item.id)) != -1 ? '&#xedaf;' : '&#xec58;'}}</i>
              <a>{{item.name}}</a>
            </li>
          </ul>
        </div>
      </div>
    </template>
    <!-- 过滤条件：尺寸 -->
    <template v-if="filterOpts.sizes.items">
      <div class="filter-item">
        <a class="item-header" @click="toggle('sizes')">
          <span :class="['title', filterOpts.sizes.collapse?'':'title-expand']">尺码</span>
          <i class="iconfont">{{filterOpts.sizes.collapse? '&#xe61e;' : '&#xe613;'}}</i>
        </a>
        <div :class="['item-list-wrapper', filterOpts.sizes.collapse?'':'active']">
          <ul class="item-list size-list box clearfix">
            <li
              v-for="(item,i) in filterOpts.sizes.items" :key="i" 
              :class="[filterOpts.sizes.checked.indexOf(String(item.id)) != -1 ? 'active' : '']" 
              @click="toggleItem('sizes', item.id)">
              <a>{{item.name}}</a>
            </li>
          </ul>
        </div>
      </div>
    </template>
    <!-- 过滤条件：颜色 -->
    <template v-if="filterOpts.colors.items">
      <div class="filter-item">
        <a class="item-header" @click="toggle('colors')">
          <span :class="['title', filterOpts.colors.collapse?'':'title-expand']">颜色</span>
          <i class="iconfont">{{filterOpts.colors.collapse? '&#xe61e;' : '&#xe613;'}}</i>
        </a>
        <div :class="['item-list-wrapper', filterOpts.colors.collapse?'':'active']">
          <ul class="item-list color-list box clearfix">
            <li
              v-for="(item,i) in filterOpts.colors.items" :key="i" 
              :class="[clsName(item.value), filterOpts.colors.checked.indexOf(String(item.name)) != -1 ? 'active': '']" 
              :style="{'background-color': item.value,}" 
              @click="toggleItem('colors', item.name)" :title="item.name">
                <a/>
                <img :src="`assets/ColorBlock/${item.value}.png`|ossPath" class="color-bg">
              </li>
          </ul>
        </div>
      </div>
    </template>
    <!-- 过滤条件：价格 -->
    <template v-if="filterOpts.prices.items">
      <div class="filter-item">
        <a class="item-header" @click="toggle('prices')">
          <span :class="['title', filterOpts.prices.collapse?'':'title-expand']">价格</span>
          <i class="iconfont">{{filterOpts.prices.collapse? '&#xe61e;' : '&#xe613;'}}</i>
        </a>
        <div :class="['item-list-wrapper', filterOpts.prices.collapse?'':'active']">
          <ul class="item-list item-icon">
            <li v-for="(item,i) in filterOpts.prices.items" :key="i" @click="toggleItem('prices', item)">
              <i class="iconfont">{{filterOpts.prices.checked == String(item) ? '&#xe654;' : '&#xe6c9;'}}</i>
              <a class="rmb-symbol">{{item}}</a>
            </li>
          </ul>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ListFilter',
  props: {
    // 使用此组件的作用域: category(类目页) / search(搜索页), 因请求接口不同用此字段作区分
    scope: String,
    filterOpts: Object,
    mode: String,
    title: String
  },
  data() {
    return { }
  },
  mounted() {
    // document.querySelectorAll(".level-2").forEach(item => item.remove())
  },
  methods: {
    toggle(opt) {
      this.filterOpts[opt].collapse = !this.filterOpts[opt].collapse;
    },
    toggleItem(opt, ref) {
      ref += '';
      // 选项处理
      let optionCache = this.filterOpts[opt];
      if (optionCache && optionCache.checked != undefined) {
        // 多选项处理
        if (Array.isArray(optionCache.checked)) {
          let optIdx = optionCache.checked.indexOf(ref);
          if (optIdx != -1) {
            optionCache.checked.splice(optIdx, 1);
          } else {
            optionCache.checked.push(ref);
          }
        } else {
          optionCache.checked = ref;
        }
        // 处理过滤条件的变动
        // 方式一: 修改地址栏参数，父组件中监听路由变化再获取参数处理
        let newQuery;
        if (optionCache.checked.length) {
          newQuery = Object.assign({}, this.$route.query, {[opt]: optionCache.checked.toString()})
        } else {
          newQuery = Object.assign({}, this.$route.query);
          delete newQuery[opt];
        }
        this.$router.push({
          path: this.$route.path,
          query: newQuery
        });
      } else {
        console.warn(`没有找到${opt}选项相关数据`);
      }
    },
    clsName(cls) {
      if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(cls)) {
        cls = cls.replace('#', '').toUpperCase();
        if (cls == 'FFFFFF' || cls == 'FFF') {
          cls = 'white'; // like-white
        } else {
          cls = `cls-${cls}`;
        }
      }
      return cls;
    }
  }
};
</script>

<style lang="scss" scoped>
  i.iconfont { color: black; }
  .filter-options {
    .title {
      line-height: calc(1.3125rem * 1.6);
      font-weight: 400;
      font-size: calc(.875rem * 1.6);
      letter-spacing: .05em;
      display: block;
      position: relative;
      margin: 0;
      padding: 15px 0;
      color: #000;
      cursor: pointer;
      text-align: left;
      &.title-2rd {
        border-bottom: 1px solid #b4b5b4;
        font-size: calc(1.5rem * 1.6);
      }
    }
    &>.title {
      font-size: calc(2rem * 1.6);
      line-height: normal;
      font-weight: 400;
      padding: 16px 0 10px;
    }
    .filter-item {
      position: relative;
      border-bottom: 1px solid #b4b5b4;
      border-width: thin;
      cursor: pointer;
      .item-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .title {
          display: inline-block;
          &.title-expand { padding-bottom: 8px; }
        }
        &:hover {
          font-weight: 400;
          color: #999;
          span { text-decoration: underline; color: #999; }
          .iconfont { text-decoration: none; }
        }
      }
      .item-list-wrapper {
        display: none;
        &.active { display: block; }
        .item-list {
          padding: 0 0 30px;
          li {
            text-align: left;
            // line-height: 1.875rem;
            line-height: 30px;
            font-size: .875rem;
            display: flex;
            align-items: center;
            a {
              // font-size: .75rem;
              font-size: 12px;
              letter-spacing: .025em;
              overflow: hidden;
              color: #666;
              text-decoration: none;
            }
          }
          &.active { display: block; }
          &.box {
            display: flex;
            flex-wrap: wrap;
            margin: 0 -5px;
            li {
              width: 40px;
              height: 35px;
              padding: 0;
              border: 1px solid #b4b5b4;
              border-radius: .5em;
              margin: 3px;
              display: flex;
              align-items: center;
              a {
                width: 100%;
                padding: 0;
                text-align: center;
                color: #000;
                border-radius: .5em;
                position: relative;
              }
              &.active {
                a {
                  color: #FFF;
                }
              }
            }
          }
          &.item-icon {
            li a { margin-left: 2px; }
          }
          &.size-list {
            li a:hover {
              font-weight: 400;
              color: #999;
            }
            li.active { background-color: #4d4d4c; }
          }
          &.color-list {
            li {
              position: relative;
              .color-bg{
                  content: "";
                  position: absolute;
                  display: block;
                  width:100%;
                  height: 100%;
              }
              a { height: 35px; }
              &.active {
                a::after {
                  content: "";
                  position: absolute;
                  z-index: 1;
                  display: block;
                  width: 4px;
                  height: 9px;
                  border: solid #fff;
                  border-width: 0 2px 2px 0;
                  left: 50%;
                  top: 50%;
                  -webkit-transform: translate(-50%,-60%) rotate(45deg);
                  -ms-transform: translate(-50%,-60%) rotate(45deg);
                  transform: translate(-50%,-60%) rotate(45deg);
                }
              }
              &.active.white, &.active.like-white {
                a::after{
                  border: solid #000;
                  border-width: 0 2px 2px 0;
                }
              }
            }
          }
        }
      }
    }
    &.filter-search {
      &>.title-1st { display: none; }
    }
  }
</style>
